import React, { Component } from 'react';
import './Button.css';

class Button extends Component {
  constructor() {
    super();
    this.state = {
      selected: false,
      backgroundColor: '#384745',
      prevColor: '#384745',
    }
  }

  // change background color if button has been selected
  _selectButton = () => {
    if(this.state.selected) {
      this.setState({ backgroundColor: '#384745', selected: false });
      this.props.unselect(this.props.name.toLowerCase());
    } else {
      this.setState({ backgroundColor: '#79B4A9', selected: true });
      this.props.select(this.props.name.toLowerCase());
    }
    // this.state.selected ? this.setState({ backgroundColor: '#384745', selected: false }) : this.setState({ backgroundColor: '#79B4A9', selected: true });
  }

  // needed since CSS :hover doesn't work
  // when changing state in react
  _hoverButton = () => {
    //var color = this.state.backgroundColor;
    this.setState({ backgroundColor: '#9CC69B' });
  }

  _unhoverButton = () => {
    this.state.selected ? this.setState({ backgroundColor: '#79B4A9'}) : this.setState({ backgroundColor: '#384745' });
    //this.setState({ backgroundColor: this.state.prevColor })
  }

  componentDidMount() {
    // console.log("button componentDidMount called");
    // console.log(this.props.name + ": " + this.props.isSelected);
    if(this.props.isSelected) {
      this.setState({ selected: true,  backgroundColor: '#79B4A9' });
    } else {
      this.setState({ selected: false, backgroundColor: '#384745' });
    }
  }

  render() {
    return (
      <div
        className={`buttonContainer ${ this.props.direc }`}
        onClick={this._selectButton}
        onMouseEnter={this._hoverButton}
        onMouseLeave={this._unhoverButton}
        style={{backgroundColor: this.state.backgroundColor}}>
      {this.props.name}
      </div>
    )
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js